const formatLabel = (label: string) => {
  return label === "cde"
    ? "CDE"
    : label.charAt(0).toUpperCase() + label.slice(1);
};
export default formatLabel;
